module.exports = __webpack_public_path__ + "static/media/google_play.663a951d.png";